const initialState = () => {
    return {
        /**
         * @description
         */
        menues: null,
        titleTopBar: 'default',
        items: [],

    }
}

export default initialState
